import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-db006f94"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "content-interaction",
  id: "content-interaction"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ContentTabMenu = _resolveComponent("ContentTabMenu")!
  const _component_ContentRating = _resolveComponent("ContentRating")!
  const _component_ContentDoubts = _resolveComponent("ContentDoubts")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ContentTabMenu, { onSelectedTab: _ctx.setCorrectComponent }, null, 8, ["onSelectedTab"]),
    _withDirectives(_createVNode(_component_ContentRating, null, null, 512), [
      [_vShow, _ctx.showRating && !_ctx.$route.query.notification]
    ]),
    _withDirectives(_createVNode(_component_ContentDoubts, null, null, 512), [
      [_vShow, _ctx.showDoubts || _ctx.$route.query.notification]
    ])
  ]))
}